import { createSlice } from '@reduxjs/toolkit';

import {
  bimehNamehMasooliatMadaniOmumiSaderShodeh,
  printBimehNamehMadani,
} from 'Feature/Asansour/Estelam/Actions/action';
import { printBimehNamehAtashsooziOmumi } from 'Feature/Atashsoozi/Detail/Action/action';
import { bimehNamehAtashsooziSaderShodeh } from 'Feature/Atashsoozi/EstelamAndSodoor/Action/action';
import { bimehNamehEnferadiSaderShodeh, printBimehNamehEnferadi } from 'Feature/Hadeseh/Estelam/Actions/action';
import { bimehNamehShakhsSalesSaderShodeh } from 'Feature/Khodro/ShakhsSales/Thunks/bimehNamehShakhsSalesSaderShodeh';
import printBimehNamehShakhsSales from 'Feature/Khodro/ShakhsSales/Thunks/printBimehNamehShakhsSales';
import { bimehNamehMosaferatiSaderShodeh, printBimehNamehMosaferati } from 'Feature/Mosaferati/Common/Actions/action';
import { getPaymentByOrderId } from 'Feature/Orders/PaymentResult/Actions/action';

import { IPaymentResultState } from './model';

const initialState: IPaymentResultState = {
  data: null,
  loading: false,
  bimehNamehSaderShodeh: null,
};

export const paymentResultSlice = createSlice({
  name: 'landing/PaymentResult',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(getPaymentByOrderId.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getPaymentByOrderId.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPaymentByOrderId.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(bimehNamehShakhsSalesSaderShodeh.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(bimehNamehShakhsSalesSaderShodeh.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.bimehNamehSaderShodeh = action.payload;
      })
      .addCase(bimehNamehShakhsSalesSaderShodeh.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(bimehNamehAtashsooziSaderShodeh.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(bimehNamehAtashsooziSaderShodeh.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.bimehNamehSaderShodeh = action.payload;
      })
      .addCase(bimehNamehAtashsooziSaderShodeh.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(bimehNamehMosaferatiSaderShodeh.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(bimehNamehMosaferatiSaderShodeh.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.bimehNamehSaderShodeh = action.payload;
      })
      .addCase(bimehNamehMosaferatiSaderShodeh.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(bimehNamehMasooliatMadaniOmumiSaderShodeh.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(bimehNamehMasooliatMadaniOmumiSaderShodeh.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.bimehNamehSaderShodeh = action.payload;
      })
      .addCase(bimehNamehMasooliatMadaniOmumiSaderShodeh.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(bimehNamehEnferadiSaderShodeh.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(bimehNamehEnferadiSaderShodeh.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.bimehNamehSaderShodeh = action.payload;
      })
      .addCase(bimehNamehEnferadiSaderShodeh.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(printBimehNamehShakhsSales.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(printBimehNamehShakhsSales.fulfilled, (state: any) => {
        state.loading = false;
      })
      .addCase(printBimehNamehShakhsSales.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(printBimehNamehMadani.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(printBimehNamehMadani.fulfilled, (state: any) => {
        state.loading = false;
      })
      .addCase(printBimehNamehMadani.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(printBimehNamehAtashsooziOmumi.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(printBimehNamehAtashsooziOmumi.fulfilled, (state: any) => {
        state.loading = false;
      })
      .addCase(printBimehNamehAtashsooziOmumi.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(printBimehNamehMosaferati.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(printBimehNamehMosaferati.fulfilled, (state: any) => {
        state.loading = false;
      })
      .addCase(printBimehNamehMosaferati.rejected, (state: any) => {
        state.loading = false;
      });

    builder
      .addCase(printBimehNamehEnferadi.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(printBimehNamehEnferadi.fulfilled, (state: any) => {
        state.loading = false;
      })
      .addCase(printBimehNamehEnferadi.rejected, (state: any) => {
        state.loading = false;
      });
  },
});

export default paymentResultSlice.reducer;
